import React from 'react';
import ReactDOM from 'react-dom';
import { Toaster } from 'sileo';
import 'sileo/styles.css';
import 'wwtc-sdk/dist/index.css';
// colocar de primero app y luego las clases que van a hacer override de las clases css
// OJO PARA LA DOCUMENTACIÓN
import App from './App';
import { toasterProps } from './notifications';
import './index.css';

ReactDOM.render(
    <>
        <Toaster {...toasterProps} />
        <App />
    </>,
    document.getElementById('root'),
);
